import { boot } from 'quasar/wrappers';
import { LOCALES } from 'src/composables/const';
import { createI18n, I18n } from 'vue-i18n';

import messages from '../i18n';

let i18n: I18n;

export default boot(({ app }) => {
  i18n = createI18n({
    legacy: false,
    locale: LOCALES.EN_US,
    globalInjection: true,
    messages,
  });
  app.use(i18n);
});

const translate = (key: string, opts?: Record<string, unknown>): string => {
  if (!key) {
    return '';
  }
  // @ts-ignore
  return i18n.global.t(key, opts) as string;
};

export { translate };
